/* eslint-disable @typescript-eslint/no-explicit-any */
import classNames from "classnames";
import { FaCompass, FaFolder } from "react-icons/fa";
// import { BsPersonFill } from "react-icons/bs";
import { IoIosDocument } from "react-icons/io";
import { MdShield } from "react-icons/md";
import ProfileAvatar from "../modules/auth/ProfileAvatar";
import { NavLink, } from 'react-router-dom';
import './layout-v2.scss';
import { useContext } from "react";
import { GlobalSettingsContext } from "../v2/context/global-settings";
import useAuth from "../hooks/auth";
import { Dropdown } from "antd";
import { AuthApi } from "../api/client";
import { BsPersonFill } from "react-icons/bs";

export const NavbarItem = ({
  children,
  to
}: any) => {
  return <li >
    <NavLink to={to || ''}

      className={({ isActive }) => {
        return classNames(
          'rounded my-1 font-semibold',
          {
            'active': isActive,
            'bg-[#dae0ff] text-[#263dff] ': isActive
          }
        );
      }}>
      {
        children
      }
    </NavLink>
  </li >
}

export const LeftNavBar = ({
  isMini
}: any) => {
  return <ul className={classNames("menu", {
    'w-48': !isMini,
  })}>
    <NavbarItem to={'/v2/explore'}>
      <FaCompass />
      {
        isMini ? "" : 'Explore'
      }
    </NavbarItem>
    <NavbarItem to={'/v2/workspace'}>
      <FaFolder />
      {
        isMini ? "" : 'WorkSpace'
      }
    </NavbarItem>
    {/* <NavbarItem to={'/v2/recents'}>
      <FaClock />
      Recents
    </NavbarItem> */}
  </ul>
}

export const LeftMenuBar = ({
  isMini
}: any) => {
  return <ul className={classNames("menu", {
    'w-48': !isMini,
  })}>
    <NavbarItem to={'/v2/billing'}>
      <BsPersonFill />
      {
        isMini ? '' : 'Billing'
      }
    </NavbarItem>
    <NavbarItem to={'/v2/api-key'}>
      <MdShield />
      {
        isMini ? '' : 'API Keys'
      }
    </NavbarItem>
    <NavbarItem to={'/v2/exploreas'}>
      <IoIosDocument />
      {
        isMini ? '' : 'Docs'
      }
    </NavbarItem>
  </ul>
}


const UserProfileMenu = ({
  isMini
}: any) => {
  const [{ auth }, { setAuth }] = useAuth();


  return <Dropdown menu={{
    items: [
      {
        key: '4',
        label: <button onClick={async () => {
          const authApi = AuthApi();
          try {
            const resp = await authApi.logoutCreate();
            if (resp.data.success) {
              setAuth(null);
            }
          } catch (error) {
            setAuth(null);
          }
        }}>
          Logout
        </button>
      },
    ]
  }}>
    <div className="flex gap-2 items-center flex-1">
      <ProfileAvatar className="w-6 bg-[#d3d3d3]" creator={{
        profileImage: auth?.profileImage,
      }} />
      {
        !isMini && <span className="font-semibold max-w-[100px]">
          {
            auth?.name || auth?.email?.split('@')[0]
          }
        </span>
      }
    </div>
  </Dropdown>
}

const MainSidebar = () => {
  const { isMiniSidebar } = useContext(GlobalSettingsContext);

  return <div className={
    classNames("bg-[#f8f7fa]  h-screen border-r-2 flex",
      {
        'max-w-[280px] min-w-[200px]': !isMiniSidebar,
      }
    )
  }>
    {
      <div className={classNames(
        "h-full flex justify-between flex-col py-0 w-full",
      )}>
        {/* top section */}
        <div >
          <div className="px-3 py-2 flex justify-center box-content">
            {/* <Logo /> */}
            <div className="flex justify-between w-full items-center">
              <UserProfileMenu isMini={isMiniSidebar} />
            </div>
          </div>
          <div className="border-b-2 mt-[-2px]">
          </div>
          <div className="flex justify-center mt-4">
            <LeftNavBar isMini={isMiniSidebar} />
          </div>

        </div>

        {/* bottom section */}
        <div className="pb-8">
          <div className="flex justify-center">
            <LeftMenuBar isMini={isMiniSidebar} />
          </div>
          {/* <div className="divider"></div>
          <div className="flex justify-between items-center gap-2 px-6">
            <div><ProfileAvatar /> <span>User Name</span></div> <FaRegBell size={20} />
          </div> */}
        </div>
      </div>
    }
    {/* <div className="group relative p-[3px] ease-out duration-500 cursor-pointer hover:bg-[#3e21ea]" onClick={toggleMiniSidebar}>
      <div className="group-hover:block hidden absolute top-[50%] right-[-20px] text-[#ddd]">
        {
          isMiniSidebar ? <IoIosArrowForward size={20} /> : <IoIosArrowBack size={20} />
        }
      </div>
    </div> */}
  </div >
}

export default MainSidebar;